const Theme = () =>
  import(
    /* webpackChunkName: "cms-theme" */ '@/pages/cms/content/theme/index.vue'
  )

const CreateTheme = () =>
  import(
    /* webpackChunkName: "cms-theme" */ '@/pages/cms/content/theme/create.vue'
  )

const EditTheme = () =>
  import(
    /* webpackChunkName: "cms-theme" */ '@/pages/cms/content/theme/edit.vue'
  )

export default {
  path: 'theme',
  meta: {
    label: 'theme',
    auth: 'theme'
  },
  component: {
    name: 'Theme',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsThemeReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Theme
    },
    {
      name: 'CmsCreateTheme',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateTheme
    },
    {
      name: 'CmsEditTheme',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditTheme,
      props: true
    }
  ]
}
